import { isMobileView, PageDefaultContainer } from "@sis/react-library"
import { LandingAction } from "../landingAction/LandingAction"
import { ScheduleMenuItems } from "../../schedule/ScheduleNavigation";
import { Box, Grid } from "@mui/material";
import { ConfigurationsMenuItems } from "../../configurations/ConfigurationsNavigation";
import { TrackMenuItems } from "../../track/TrackNavigation";
import sisbackground from '../../../assets/SIS_Background.jpg';

export const LandingPage = () => {

    const isMobile = isMobileView();

    const bgcolor1 = "rgba(160, 160, 160, 0.6)";
    const bgcolor2 = "rgba(120, 120, 120, 0.6)";

    return (
        <Box sx={{
            background: `url(${sisbackground}) center/cover`,
            height: `calc(100vh - 62px)`
        }}
        >
            <PageDefaultContainer
                noHeader
                background={`linear-gradient(to bottom right, ${bgcolor1}, ${bgcolor2},${bgcolor2}, ${bgcolor1})`}
            >
                <title>Racing Pricing Manager</title>
                <Grid
                    container
                    id="landing-action-items"
                    sx={{
                        paddingTop: isMobile ? '0' : 'calc(50vh - 270px)',
                        direction: "row", justifyContent: "center", alignItems: "center"
                    }}
                >
                    <LandingAction
                        menuItems={ScheduleMenuItems()}
                        delay={0}
                    />
                    <LandingAction
                        menuItems={ConfigurationsMenuItems()}
                        delay={300}
                    />
                    <LandingAction
                        menuItems={TrackMenuItems()}
                        delay={600}
                    />
                </Grid>
            </PageDefaultContainer >
        </Box>
    )
}
